import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import store from '@/store';
import axios, { axiosRefreshToken } from '@/plugins/axios';

import LoginView from '@/views/login/LoginView.vue';
import LoginForgetView from '@/views/login/LoginForgetView.vue';
import PasswordReset from '@/views/login/PasswordReset.vue';
import JobSearchView from '@/views/search/JobSearchView.vue';
import JobSearchPublicView from '@/views/search/JobSearchPublicView.vue';
import JobSearchDetailView from '@/views/search/JobSearchDetailView.vue';

import HomeView from '@/views/home/Index.vue';
import PendingView from '@/views/pending/PendingView.vue';
import ApplyFormView from '@/views/apply/ApplyFormView.vue';
import ApplyMultipleView from '@/views/apply/ApplyMultipleView.vue';
import RefusalFormView from '@/views/refusal/RefusalFormView.vue';
import RefusalMultipleView from '@/views/refusal/RefusalMultipleView.vue';
import NewsView from '@/views/news/NewsView.vue';
import RecommendView from '@/views/recommend/RecommendView.vue';
import RefusalListView from '@/views/refusal/RefusalListView.vue';
import ProfilePasswordEditView from '@/views/profile/PasswordEditView.vue';
import NotFoundView from '@/views/error/NotFoundView.vue';
import MaintenanceView from '@/views/maintenance/MaintenanceView.vue';
import SendSettingView from '@/views/sendsetting/SendSettingView.vue';
import VideoListView from '@/views/video/VideoListView.vue';
import VideoDetailView from '@/views/video/VideoDetailView.vue';
import CreateResumeView from '@/views/resume/CreateResumeView.vue';
import SubmitAdvisorView from '@/views/resume/SubmitAdvisorView.vue';
import RecommendFormView from '@/views/recommend/RecommendFormView.vue';
import PwupdateView from '@/views/pwupdate/PwupdateView.vue';
import ResumeFormView from '@/views/resume/ResumeFormView.vue';
import ApplyClosedView from '@/views/apply/ApplyClosedView.vue';
import ApplyView from '@/views/apply/ApplyView.vue';
import { accountUtils } from '@/utils/account';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import MailSecuritySettingView from '@/views/mailSecurity/MailSecuritySettingView.vue';
import MailSecurityFormView from '@/views/mailSecurity/MailSecurityFormView.vue';
import MailSecurityCompleteView from '@/views/mailSecurity/MailSecurityCompleteView.vue';
import MailSecurityErrorView from '@/views/mailSecurity/MailSecurityErrorView.vue';
import MailSecurityCertificationCompleteErrorView from '@/views/mailSecurity/MailSecurityCertificationCompleteErrorView.vue';
import MailSecurityVerifyView from '@/views/mailSecurity/MailSecurityVerifyView.vue';
import VerifyByPasswordView from '@/views/mailSecurity/VerifyByPasswordView.vue';
import { MailSecurityInfoDetail } from '@/types/emailSerurity';
import CP2MailSecurityErrorView from '@/views/mailSecurityCp2/MailSecurityErrorView.vue';
import CP2MailSecurityCertificationCompleteErrorView from '@/views/mailSecurityCp2/MailSecurityCertificationCompleteErrorView.vue';
import CP2MailSecurityVerifyView from '@/views/mailSecurityCp2/MailSecurityVerifyView.vue';
import CP2MailSecuritySuccessView from '@/views/mailSecurityCp2/MailSecuritySuccessView.vue';
import CP2VerifyByPasswordView from '@/views/mailSecurityCp2/VerifyByPasswordView.vue';


export type Title = string;
export type Header = 'none' | 'home' | 'login' | 'pending'| 'refusal' | 'jobsearch' | 'notFound' | 'apply' | 'menu' | 'sp-none' | 'mypage';
export type Footer = 'none' | 'home' | 'pending'| 'refusal' | 'jobsearch' | 'notFound' | 'applymulti' | 'refusalmulti' | 'apply' | 'menu' | 'recommendform' | 'resumeform';
export type HeaderTitle = string;
export type NavBar = boolean;
export type SpHeaderBackLink = boolean;

export type Route = RouteRecordRaw & {
  meta?: RouteRecordRaw['meta'] & {
    title?: Title;
    header?: Header;
    headerTitle?: HeaderTitle;
    footer?: Footer;
    spHeaderBackLink?: SpHeaderBackLink;
  };
};

const routes: Array<Route> = [
  // A_10 ログイン
  {
    strict: true,
    path: '/login/',
    name: 'a10',
    component: LoginView,
    meta: {
      title: 'ログイン｜マイページ｜マイナビ転職エージェント',
      header: 'login',
      headerTitle: 'マイページ',
    },
  },
  // A_20 パスワードを忘れた・ログインできない方へ
  {
    strict: true,
    path: '/pwreregister/form',
    name: 'a20',
    component: LoginForgetView,
    meta: {
      title: 'パスワードを忘れた・ログインできない方へ｜マイページ｜マイナビ転職エージェント',
      header: 'login',
      headerTitle: 'マイページ',
    },
  },
  // A_21 初回パスワード設定
  {
    strict: true,
    path: '/pwregister/form/:uniqueKey',
    name: 'a21',
    component: PasswordReset,
    meta: {
      title: '初回パスワード設定｜マイページ｜マイナビ転職エージェント',
      header: 'login',
      headerTitle: 'マイページ',
    },
  },
  // E_25,N_25 パスワード_変更画面
  {
    strict: true,
    path: '/profile/passwordedit/form/',
    name: 'e25',
    component: ProfilePasswordEditView,
    meta: {
      title: 'パスワード変更｜マイページ｜マイナビ転職エージェント',
      //header: 'typeC',
      headerTitle: 'マイページ',
    },
  },
  // F_00 ホーム画面
  {
    strict: true,
    path: '/',
    name: 'f00',
    component: HomeView,
    meta: {
      title: 'ホーム｜マイページ｜マイナビ転職エージェント',
      header: 'home',
      footer: 'home',
      headerTitle: 'マイページ',
    },
  },
  // R_00 お知らせ画面
  {
    strict: true,
    path: '/news/:newsId',
    name: 't00',
    component: NewsView,
    meta: {
      title: 'お知らせ｜マイページ｜マイナビ転職エージェント',
      header: 'sp-none',
      footer: 'home',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // H_00 求人一覧(紹介求人)
  {
    strict: true,
    path: '/jobsearch/',
    name: 'h00',
    component: JobSearchView,
    meta: {
      title: '紹介求人｜マイページ｜マイナビ転職エージェント',
      header: 'jobsearch',
      footer: 'jobsearch',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
 // H_01 求人一覧(公開求人)
  {
    strict: true,
    path: '/jobsearch/public/',
    name: 'h01',
    component: JobSearchPublicView,
    meta: {
      title: '公開求人｜マイページ｜マイナビ転職エージェント',
      header: 'jobsearch',
      footer: 'jobsearch',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
 // G_00 求人詳細
  {
    strict: true,
    path: '/jobsearch/detail/:orderId',
    name: 'g00',
    component: JobSearchDetailView,
    meta: {
      title: '紹介求人詳細｜マイページ｜マイナビ転職エージェント',
      header: 'sp-none',
      footer: 'jobsearch',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // G_01 求人詳細
  {
    strict: true,
    path: '/jobsearch/detail/:orderId/:form',
    name: 'g01',
    component: JobSearchDetailView,
    meta: {
      title: '公開求人詳細｜マイページ｜マイナビ転職エージェント',
      header: 'sp-none',
      footer: 'jobsearch',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // I_00 気になるリスト
  {
    strict: true,
    path: '/pending/',
    name: 'i00',
    component: PendingView,
    meta: {
      title: '気になるリスト｜マイページ｜マイナビ転職エージェント',
      header: 'pending',
      footer: 'pending',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // J_00 応募確認
  {
    strict: true,
    path: '/apply/form/:orderId/:screenName',
    name: 'j00',
    component: ApplyFormView,
    meta: {
      title: '応募確認｜マイページ｜マイナビ転職エージェント',
      header: 'sp-none',
      footer: 'jobsearch',
      headerTitle: 'マイページ',
      backGround: 'is-blue',
    },
  },
  // J_01 一括応募確認
  {
    strict: true,
    path: '/apply/multiple/',
    name: 'j01',
    component: ApplyMultipleView,
    meta: {
      title: '一括応募確認｜マイページ｜マイナビ転職エージェント',
      header: 'sp-none',
      footer: 'applymulti',
      headerTitle: 'マイページ',
      backGround: 'is-blue',
    },
  },
  // K_00 応募辞退
  {
    strict: true,
    path: '/refusal/form/:orderId',
    name: 'k00',
    component: RefusalFormView,
    meta: {
      title: '応募辞退｜マイページ｜マイナビ転職エージェント',
      header: 'sp-none',
      footer: 'jobsearch',
      headerTitle: 'マイページ',
      backGround: 'is-blue',
    },
  },
  // K_01 一括応募辞退
  {
    strict: true,
    path: '/refusal/multiple',
    name: 'k01',
    component: RefusalMultipleView,
    meta: {
      title: '一括応募辞退｜マイページ｜マイナビ転職エージェント',
      header: 'sp-none',
      footer: 'refusalmulti',
      headerTitle: 'マイページ',
      backGround: 'is-blue',
    },
  },
 // M_00 応募しない求人一覧
  {
    strict: true,
    path: '/refusallist/',
    name: 'm00',
    component: RefusalListView,
    meta: {
      title: '応募しない求人一覧｜マイページ｜マイナビ転職エージェント',
      header: 'refusal',
      footer: 'refusal',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // N_00 応募管理
  {
    strict: true,
    path: '/apply/',
    name: 'n00',
    component: ApplyView,
    meta: {
      title: '応募管理｜マイページ｜マイナビ転職エージェント',
      header: 'apply',
      footer: 'apply',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // N_01 選考終了一覧
  {
    strict: true,
    path: '/apply/closed/',
    name: 'n01',
    component: ApplyClosedView,
    meta: {
      title: '選考終了一覧｜マイページ｜マイナビ転職エージェント',
      header: 'sp-none',
      footer: 'apply',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // O_00 配信設定
  {
    strict: true,
    path: '/sendsetting/',
    name: 'o00',
    component: SendSettingView,
    meta: {
      title: '配信設定｜マイページ｜マイナビ転職エージェント',
      header: 'menu',
      footer: 'menu',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // P_00 ノウハウ動画一覧
  {
    strict: true,
    path: '/video/',
    name: 'p00',
    component: VideoListView,
    meta: {
      title: '転職活動ノウハウ動画｜マイページ｜マイナビ転職エージェント',
      header: 'menu',
      footer: 'menu',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // P_01 転職活動ノウハウ動画_詳細ページ
  {
    strict: true,
    path: '/video/knowhow/:knowhowId',
    name: 'p01',
    component: VideoDetailView,
    meta: {
      title: '転職活動ノウハウ動画_詳細ページ｜マイページ｜マイナビ転職エージェント',
      header: 'menu',
      footer: 'menu',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // C_00 書類作成
  {
    strict: true,
    path: '/resume/',
    name: 'c00',
    component: CreateResumeView,
    meta: {
      title: '書類作成｜マイページ｜マイナビ転職エージェント',
      header: 'menu',
      footer: 'menu',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // C_01 書類作成編集
  {
    strict: true,
    path: '/resume/form/',
    name: 'c01',
    component: ResumeFormView,
    meta: {
      title: '書類作成編集｜マイページ｜マイナビ転職エージェント',
      header: 'sp-none',
      footer: 'menu',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // C_03 書類作成提出
  {
    strict: true,
    path: '/resume/submitadvisor/',
    name: 'c03',
    component: SubmitAdvisorView,
    meta: {
      title: '書類作成｜マイページ｜マイナビ転職エージェント',
      header: 'menu',
      footer: 'menu',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // Q_00 転職希望アンケート
  {
    strict: true,
    path: '/recommend/',
    name: 'q00',
    component: RecommendView,
    meta: {
      title: '転職希望アンケート｜マイページ｜マイナビ転職エージェント',
      header: 'menu',
      footer: 'menu',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // Q_01 転職希望アンケート編集
  {
    strict: true,
    path: '/recommend/form/',
    name: 'q01',
    component: RecommendFormView,
    meta: {
      title: '転職希望アンケート_編集画面｜マイページ｜マイナビ転職エージェント',
      header: 'sp-none',
      footer: 'recommendform',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // L_00 パスワード更新
  {
    strict: true,
    path: '/pwupdate/form/',
    name: 'l00',
    component:PwupdateView,
    meta: {
      title: 'パスワード更新｜マイページ｜マイナビ転職エージェント',
      header: 'menu',
      footer: 'menu',
      headerTitle: 'マイページ',
      backGround: 'is-gray',
    },
  },
  // 503
  {
    strict: true,
    path: '/maintenance/',
    name: '503',
    component: MaintenanceView,
    meta: {
      title: 'メンテナンス｜マイページ｜マイナビ転職エージェント',
      header: 'login',
      headerTitle: 'マイページ',
    },
  },
  // 404
  {
    path: '/:catchAll(.*)',
    name: 'xx404',
    meta: {
      title: 'お探しのページが見つかりませんでした｜マイページ｜マイナビ転職エージェント',
      header: 'notFound',
      footer: 'notFound',
    },
    component: NotFoundView,
  },
  {
    path: '/mail_security/setting',
    name: 'mss02',
    meta: {
      header: 'login',
      title: '設定状況｜マイページ｜マイナビ転職エージェント',
    },
    component: MailSecuritySettingView,
  },
  {
    path: '/mail_security/form',
    name: 'mss03',
    meta: {
      header: 'login',
      footer: 'none',
      title: '変更画面｜マイページ｜マイナビ転職エージェント',
    },
    component: MailSecurityFormView,
  },
  {
    path: '/mail_security/complete',
    name: 'mss04',
    meta: {
      header: 'login',
      title: '設定完了｜マイページ｜マイナビ転職エージェント',
    },
    component: MailSecurityCompleteView,
  },
  {
    path: '/mail_security/72_error',
    name: 'mss071',
    meta: {
      header: 'login',
      title: '認証URLの有効期限が過ぎています｜マイページ｜マイナビ転職エージェント',
    },
    component: MailSecurityErrorView,
  },
  {
    path: '/mail_security/certification_complete_error',
    name: 'mss09',
    meta: {
      header: 'login',
      title: 'エラー｜マイページ｜マイナビ転職エージェント',
    },
    component: MailSecurityCertificationCompleteErrorView,
  },
  {
    path: '/complete-registration/:mailAuthKey',
    name: 'complete-registration',
    meta: {
      header: 'none',
      title: '確認する',
    },
    component: MailSecurityVerifyView,
  },
  {
    path: '/verify-by-password/:mailAuthKey',
    name: 'verify-by-password',
    meta: {
      header: 'login',
      title: '認証確認｜マイページ｜マイナビ転職エージェント',
    },
    component: VerifyByPasswordView,
  },
  {
    path: '/verify-mypage-password/:mailAuthKey',
    name: 'verify-mypage-password',
    meta: {
      header: 'login',
      title: '認証確認｜マイページ｜マイナビ転職エージェント',
    },
    component: CP2VerifyByPasswordView,
  },
  {
    path: '/cp2/mail_security/72_error',
    name: 'cp2mss071',
    meta: {
      header: 'login',
      title: '認証URLの有効期限が過ぎています｜マイナビ転職エージェント',
    },
    component: CP2MailSecurityErrorView,
  },
  {
    path: '/cp2/mail_security/certification_complete_error',
    name: 'cp2mss09',
    meta: {
      header: 'login',
      title: 'エラー｜マイナビ転職エージェント',
    },
    component: CP2MailSecurityCertificationCompleteErrorView,
  },
  {
    path: '/cp2/complete-registration/:mailAuthKey',
    name: 'cp2-complete-registration',
    meta: {
      header: 'none',
      title: '確認する(CP2)',
    },
    component: CP2MailSecurityVerifyView,
  },
  {
    path: '/cp2/mail_security/certification_complete_success',
    name: 'cp2-complete-registration-success',
    meta: {
      header: 'login',
      title: '認証完了｜マイナビ転職エージェント',
    },
    component: CP2MailSecuritySuccessView,
    props: (route) => ({
      email: route.query.email
    }),
  },
];

const base = '';
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL + base),
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (to.hash) {
        return;
      }
      return { top: 0 };
    }
  },
});

// title設定
router.beforeEach(async (to, from, next) => {

  // メンテナンス状態をチェック
  const res = await axios.get(process.env.UNDER_MAINTENANCE_URL_ENDPOINT);
  if (res.data !== 0) {
    // アクセス先がすでにメンテナンス画面の場合は、無限リダイレクトを防ぐためにナビゲーションを続行
    if (to.path === '/maintenance/') {
      next();
      return;
    }
    // それ以外のパスへのアクセスはメンテナンス画面にリダイレクト
    next({ path: '/maintenance/' });
    return;
  }

  const mailSecurityAuthenticated = async () => {
    await store.dispatch('mailSecurity/receive');
    const mailSecurityInfo = store.getters['mailSecurity/mailSecurity'] as MailSecurityInfoDetail;
    return mailSecurityInfo && mailSecurityInfo?.email1AuthFlg == 1 && !mailSecurityInfo?.isFirstLogin;
  };

  const isFirstLogin = async () => {
    await store.dispatch('mailSecurity/receive');
    const mailSecurityInfo = store.getters['mailSecurity/mailSecurity'] as MailSecurityInfoDetail;
    return mailSecurityInfo && mailSecurityInfo?.isFirstLogin;
  };

  const toPathPage = to.path.trim().endsWith('/') ? to.path.slice(0, -1) : to.path;
  const fromPathPage = from.path.trim().endsWith('/') ? from.path.slice(0, -1) : from.path;

  // mail_security/form のヘッダとフッターを動的に設定
  if (toPathPage === '/mail_security/form') {
    await store.dispatch('mailSecurity/receive');
    const mailSecurityInfo = store.getters['mailSecurity/mailSecurity'] as MailSecurityInfoDetail;
    // メールアドレス1が認証済の場合はHeaderMyPageとフッターを表示
    if (mailSecurityInfo?.email1AuthFlg === 1) {
      to.meta.header = 'mypage';
      to.meta.footer = 'home';
    }
  }

  // mail_security/complete のヘッダを遷移元に応じて動的に設定
  if (toPathPage === '/mail_security/complete') {
    const commonLayoutFlag = !!store.getters['mailSecurity/mailSecurityCommonLayout'];

    to.meta.header = commonLayoutFlag ? 'mypage' : 'login';
    to.meta.footer = commonLayoutFlag ? 'home' : 'none';
  }

  const blockedAfterLoginPages = ['/mail_security/setting'];
  const mailSecurityPages = [...blockedAfterLoginPages, '/mail_security/form', '/mail_security/complete'];
  const mailSecurityPublicPages = ['/complete-registration', '/mail_security/certification_complete_error', '/mail_security/72_error', '/verify-by-password'];
  const mailSecurityCp2PublicPages = ['/cp2/complete-registration', '/cp2/mail_security/certification_complete_error', '/cp2/mail_security/72_error', '/cp2/mail_security/certification_complete_success', '/verify-mypage-password'];
  const publicPages = [...mailSecurityPublicPages ,...mailSecurityCp2PublicPages, '/login', '/pwreregister/form', '/pwregister/form', '/maintenance', '/complete-registration'];
  const authRequired = !publicPages.some(_path => toPathPage.indexOf(_path) != -1) && !toPathPage.startsWith('/pwregister/form');

  if (authRequired) {
    const logout = () => {
      store.commit('router/setLoginTransitionData', to);
      store.dispatch('careerId/clear');
      store.dispatch('mailSecurity/clear');
      store.dispatch('mailSecurity/clearHomePopupDismissed');
      // redirect to login page
      next({ name: 'a10' });
    }

    if (!accountUtils.isLogin()) {
      logout();
      return;
    }
    if (accountUtils.isAccessTokenExpired()) {
      const isSuccess = await axiosRefreshToken();
      if (!isSuccess) {
        logout();
        return;
      }
    }

    // If account not yet Email1 Authenticated and not yet First Login
    if (!await mailSecurityAuthenticated()) {
      const firstLogin = sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.IS_FIRST_LOGIN) === 'true' || await isFirstLogin();

      if (!firstLogin) {
        // Check if email1 has active pending auth (changed email, waiting verification)
        const mailSecurityInfo = store.getters['mailSecurity/mailSecurity'] as MailSecurityInfoDetail;
        const email1PendingAuth = mailSecurityInfo && mailSecurityInfo.email1AuthFlg !== 1 && mailSecurityInfo.hasEmail1AuthKey && !mailSecurityInfo.isEmail1AuthExpired;
        const email1ExpiredAuth = mailSecurityInfo && mailSecurityInfo.email1AuthFlg !== 1 && mailSecurityInfo.hasEmail1AuthKey && mailSecurityInfo.isEmail1AuthExpired;

        // Allow Home for email1 pending auth (Home will show blocking popup) or expired auth (Home will show expired popup)
        const allowedPages = (email1PendingAuth || email1ExpiredAuth) ? [...mailSecurityPages, ''] : mailSecurityPages;

        if(!allowedPages.includes(toPathPage)) {
          logout();
          return;
        }

        if(!email1PendingAuth && blockedAfterLoginPages.includes(toPathPage)) {
          next('/');
          return;
        }
      }
      // First login: allow all pages (Home will show setting modal)
    } else {
      // After Login and Email1 Authenticated, If user trying access to blockedAfterLoginPages then redirect to /
      if (blockedAfterLoginPages.includes(toPathPage)) {
        next('/');
        return;
      }
    }

    if(fromPathPage != '/mail_security/form' && toPathPage == '/mail_security/complete') {
      next('/');
    }
  }

  // pathの末尾に/がない場合は、/を付与して遷移する
  if (to.path.slice(-1) !== '/') {
    const path = to.path + '/';
    const name = routes.filter((route) => route.name !== 'xx404' && route.path === path)[0]?.name || '';
    if (name) {
      next({ name, query: to.query || {}, params: to.params || {} });
      return;
    }
  }
  if (to.meta.title) {
    document.title = `${to.meta.title}`;
  }
  if (to.meta.backGround) {
    if (from.meta.backGround != to.meta.backGround) {
      document.body.classList.remove(from.meta.backGround as string);
      document.body.classList.add(to.meta.backGround as string);
    }
  }
  if (from.meta.backGround && !to.meta.backGround) {
    document.body.className = '';
  }

  if (from && from.name) {
    store.commit('router/setPreviousRoute', from);
  }

  // Add meta tag with content index/noindex, follow/nofollow
  const oldMetaIndex = document.querySelector('meta[name="robots"]');
  if (oldMetaIndex) oldMetaIndex.remove();

  let metaContent = 'noindex, nofollow';

  // Set the meta tag to “index, follow” for the login page
  if (to.path === '/login/') {
    metaContent = 'index, follow';
  }

  const metaIdx = document.createElement('meta');
  metaIdx.name = 'robots';
  metaIdx.content = metaContent;
  document.head.appendChild(metaIdx);
  next();
});

export function setupGtmRouteTracking(app: any) {
  router.afterEach((to) => {
    if (app.config.globalProperties.$gtm) {
      app.config.globalProperties.$gtm.trackPage({
        page: to.fullPath,
        title: to.meta.title || document.title
      });
    }
  });
}

let lastPosition: number | null = null;
router.afterEach((to) => {
  const currentPos = window.history.state?.position ?? null
  const isBack = lastPosition !== null && currentPos !== null && currentPos < lastPosition

  // Flag for the component to read in onActivated
  to.meta.isBack = isBack

  // Update for next time
  lastPosition = currentPos
});

export default router;
